import React, {useState, useEffect} from "react";
import { useHistory } from 'react-router-dom';
import Layout from "../../core/Layout";
import Jumbotron from "../../core/Jumbotron";
import { isAuthenticated } from "../../auth";
import { 
  getAllSubmittedProof,
  getAllAcceptedProof,
  getDeclinedProof, 
  storeUserBalance, 
  updateProofStatus,
  updateProofStatusDecl,
  storeTransaction 
} from "./walletFetchApi"
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import SubmittedProofTable from "./component/table"
import AcceptedProofTable from "./component/acceptedTable"
import DeclinedProofTable from "./component/declinedTable"

const SparkleWallet = () => {
  const history = useHistory();
  const { token, user } = isAuthenticated();
  const [tableRows,setTableRows] = useState([]);
  const [sendData, setSendData ] = useState()
  const [acceptedTable,setAcceptedTable] = useState([])
  const [declinedTable, setDeclinedTable] = useState([])
  const [value, setValue] = React.useState('1');
  
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //get the vouchers

  const handleAccept = (id, proofId, amount, accountName, referenceNumber) => {
   const dataSend ={
     accountName: accountName,
     netAmount: amount,
     currency: 'PH',
     userIdProof: id,
     status:1
   }
   
   storeUserBalance(user._id, dataSend, token).then((data =[]) =>{
    if (data && data.error) {
      console.log(data.error) 
    } else {
      if(data){
        updateProofStatus(proofId, token)
        .then((data = []) =>{
            if(data.error){
              console.log("Error sa Update", data.error)
            }
            else{
             
              const dataTransac = {
                status:"Accepted",
                referenceNum:referenceNumber
              }
              storeTransaction(id, dataTransac, token)
              .then((data = []) =>{
                if(data.error){
                  console.log("Store Transaction Error", data.error)
                }else{
                  alert('Accepted')
                  window.location.reload();
                }
              })
            }
        })
      } 
    }
  }) 
  };
  
  const handleDelete = (userId,proofId, referenceNumber) =>{
    updateProofStatusDecl(proofId, token)
        .then((data = []) =>{
          const dataTransac = {
            status:"Declined",
            referenceNum:referenceNumber
          }
          storeTransaction(userId, dataTransac, token)
          .then((data = []) =>{
            if(data.error){
              console.log("Store Transaction Error", data.error)
            }else{
              alert("Declined")
            }
          })

        })
  }
  useEffect(() =>{
    getAllSubmittedProof(token)
      .then((data) => {
        setTableRows(data)
        setSendData(data)
      })
      .catch((err) =>{
        console.log(err)
      })

    getAllAcceptedProof(token)
      .then((data) =>{
        setAcceptedTable(data)
      })
      .catch((err) =>{
        console.log(err)
      })

      getDeclinedProof(token)
        .then((data) =>{
          setDeclinedTable(data)
        })
        .catch((err) =>{
          console.log(err)
        })
  },[])
 
  return (
    <Layout>
      <div>
        <Jumbotron
          title="Wallet"
          description={`G'day , you can manage all the submitted proof here`}
        />
      </div>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Submitted Proof" value="1" />
              <Tab label="Accepted Proof" value="2" />
              <Tab label="Declined Proof" value="3" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <SubmittedProofTable 
              tableRows={tableRows} 
              handleAccept={handleAccept}
              handleDelete={handleDelete}
            />
          </TabPanel>
          <TabPanel value="2">
            <AcceptedProofTable 
              acceptedTable={acceptedTable}
            />
          </TabPanel>
          <TabPanel value="3">
            <DeclinedProofTable 
              declinedTable={declinedTable}
            />
          </TabPanel>
        </TabContext>
      </Box>
    </Layout>
  );
};

export default SparkleWallet;
